import React, { memo } from 'react'

import { isRecipeFineDineIn, Recipe } from '@library/menu-service'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'

import { OrderedRecipe } from './OrderedRecipe/OrderedRecipe'

export const RecipeSummary = memo(() => {
  const { basketRecipes } = useBasketRecipes()
  const loadedRecipes = basketRecipes
    .map(({ recipe }) => recipe)
    .filter((recipe): recipe is Recipe => Boolean(recipe))

  return (
    <div data-testid="checkoutRecipeSummary">
      {loadedRecipes.map((recipe) => (
        <OrderedRecipe
          key={recipe.id}
          name={recipe.name}
          crops={recipe.images[0]?.crops || []}
          isFineDineIn={isRecipeFineDineIn(recipe)}
        />
      ))}
    </div>
  )
})

RecipeSummary.displayName = 'RecipeSummary'
